<script setup lang="ts">
import BaseStatistics from '@desktop/views/Relation/Sports/components/RelationView/BaseStatistics.vue'

import { useBasketballSeasonDetails } from '../../composables'
import {
  getPlayerStatIdConfigs,
  getTeamStatIdConfigs,
  getTeamStatsAccordionIdConfigs,
} from '../../configuration'

// composables
const { isFourPointsShotEnabled } = useBasketballSeasonDetails()

// data
const playerStatIdConfigs = getPlayerStatIdConfigs(isFourPointsShotEnabled)
const teamStatIdConfigs = getTeamStatIdConfigs(isFourPointsShotEnabled)
const teamStatsAccordionIdConfigs = getTeamStatsAccordionIdConfigs(
  isFourPointsShotEnabled,
)
</script>

<template>
  <BaseStatistics
    :playerStatIdConfigs
    :teamStatIdConfigs
    :teamStatsAccordionIdConfigs
  />
</template>
